export default __webpack_public_path__ + "static/media/red-icon.14798490.svg";